<template>
  <div>
    <div class="tabs margin aclear">
      <div class="tab" :class="tabid===1 ? 'on' : ''" @click="setTabid(1)"><div class="tab_in">1</div></div>
      <div class="tab" :class="tabid===2 ? 'on' : ''" @click="setTabid(2)"><div class="tab_in">2</div></div>
      <div class="tab" :class="tabid===3 ? 'on' : ''" @click="setTabid(3)"><div class="tab_in">3</div></div>
      <div class="tab" :class="tabid===4 ? 'on' : ''" @click="setTabid(4)"><div class="tab_in">4</div></div>
      <div class="tab" :class="tabid===5 ? 'on' : ''" @click="setTabid(5)"><div class="tab_in">5</div></div>
      <div class="tab" :class="tabid===6 ? 'on' : ''" @click="setTabid(6)"><div class="tab_in">6</div></div>
      <div class="clear"></div>
    </div>

    <HtmlBox v-show="tabid===1" boxid="1" />
    <HtmlBox v-show="tabid===2" boxid="2" />
    <HtmlBox v-show="tabid===3" boxid="3" />
    <HtmlBox v-show="tabid===4" boxid="4" />
    <HtmlBox v-show="tabid===5" boxid="5" />
    <HtmlBox v-show="tabid===6" boxid="6" />

    <br />
    <hr />

    <TagsSearch />

    <div class="margin txt">1. 该程序可以自动把咒语转换为<code>SD</code>和<code>Naifu</code>2种格式，并清除部分垃圾代码。<br />2. 本页面纯静态，无搜集用户数据，数据自动缓存到本地。<br />3. 支持转换<code>(1girl:1.2)</code>这种类型的语法。<br />4. 支持输入回车自动排版，大写转小写，清除多余空格。<br />5. 支持各种错误符号转正，包括：<code>（</code><code>）</code><code>，</code><code>：</code><br />6. 可使用<code>//</code>和<code>/*</code>...<code>*/</code>用来注释代码<br /><br /><p style="text-align: right;">作者：ovsexia，转载注明出处</p><p style="text-align: right;"><a href="http://mantra.ovsexia.com/mantra/see/" target="_blank">法术解析</a></p><br /></div>
  </div>
</template>

<script>
import HtmlBox from './HtmlBox.vue'
import TagsSearch from './TagsSearch.vue'

export default {
  name: 'HtmlPage',
  created(){
    this.keyboardListen();
    let mantra_tabid = Number(localStorage.getItem('mantra_tabid'));
    if(mantra_tabid && mantra_tabid!=1){
      this.setTabid(mantra_tabid);
    }
  },
  components: {
    HtmlBox,
    TagsSearch,
  },
  data(){
    return {
      tabid: 1,
    }
  },  
  methods: {
    setTabid(id){
      this.tabid = id;
      localStorage.setItem('mantra_tabid', id);
    },
    keyboardListen(){
      document.addEventListener('keyup', (e)=>{
        if(e.target.localName!='input' && e.target.localName!='textarea'){
          if(e.keyCode==49){  //1
            this.setTabid(1);
          }else if(e.keyCode==50){
            this.setTabid(2);
          }else if(e.keyCode==51){
            this.setTabid(3);
          }else if(e.keyCode==52){
            this.setTabid(4);
          }else if(e.keyCode==53){
            this.setTabid(5);
          }else if(e.keyCode==54){
            this.setTabid(6);
          }else if(e.keyCode==37){
            let prev = this.tabid - 1;
            if(prev < 1){
              prev = 6;
            }
            this.setTabid(prev);
          }else if(e.keyCode==39){
            let next = this.tabid + 1;
            if(next > 6){
              next = 1;
            }
            this.setTabid(next);
          }
        }
      });
    },
  },
}
</script>

<style scoped>
.tabs {padding-top: 20px; border-bottom: 1px solid #ccc;}
.tab {width: calc(100% / 6); float: left; font-size: 15px; height: 32px; line-height: 32px; cursor: pointer;}
.tab_in {border: 1px solid #ccc; border-bottom: 0; border-radius: 8px 8px 0 0; text-align: center; overflow: hidden; box-sizing: border-box;}
.tab:hover .tab_in {background-color: #c3d7ea;}
.tab.on .tab_in {background-color: #3a97ef; border-color: #3a97ef; color: #fff;}
.txt {font-size: 15px; line-height: 26px; padding-top: 14px;}
code {display: inline-block; background-color: #f0f0f0; border: 1px solid #ccc; border-radius: 2px; margin: 0 5px; padding: 0 6px;}
</style>